export {
  useSentenceExamplesQueryOptions,
  SENTENCE_EXAMPLES_LIMIT,
  type SentenceExample,
} from "#read-sentence-examples";
